/*
 * @Author: 吴文洁
 * @Date: 2019-09-12 14:01:43
 * @LastEditors: 吴文洁
 * @LastEditTime: 2019-09-12 17:27:04
 * @Description: 
 */
export default {
  routes: [{
    path: '/transcript/list',
    name: 'transcript_list',
    component: () => import('@/module/transcript/TranscriptListPage.vue'),
    meta: {
      title: '成绩单',
      keepAlive: false,
      logined: true
    }
  }, {
    path: '/transcript/detail',
    name: 'transcript_detail',
    component: () => import('@/module/transcript/TranscriptDetailPage.vue'),
    meta: {
      title: '成绩单详情',
      keepAlive: false,
      logined: true
    }
  }]
}


// WEBPACK FOOTER //
// ./src/router/Transcript.js